import fetchServer from "../fetchServer";

export default async function getSinglePriceFreeze(priceFreezeId) {
  let result = {
    return: 0,
    msg: "Failed to fetch price freeze",
    data: null,
  };

  if (!priceFreezeId) {
    result.msg = "Price freeze ID is missing";
    return result;
  }

  await fetchServer({
    method: "GET",
    url: `/payment/v1/payment/single-price-freeze/${priceFreezeId}`,
  })
    .then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        result = {
          return: 1,
          msg: res?.data?.message || "Success",
          data: res?.data?.data ?? res?.data,
        };
        return;
      }

      result.msg =
        res?.data?.error ||
        res?.error ||
        res?.data?.message ||
        res?.message ||
        result.msg;

      if (typeof result.msg !== "string") {
        result.msg =
          result.msg?.message ||
          result.msg?.error ||
          "Failed to fetch price freeze";
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
      } else if (err?.message) {
        result.msg = err.message;
      }
    });

  return result;
}
